module.exports = __webpack_public_path__ + "img/vv.64827dee.jpg";